import { render, staticRenderFns } from "./ModernInput.vue?vue&type=template&id=1bf01490&scoped=true&"
import script from "./ModernInput.vue?vue&type=script&lang=js&"
export * from "./ModernInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf01490",
  null
  
)

export default component.exports